export const USER_SENDING_REQUEST = "USER_SENDING_REQUEST"
export const USER_REQUEST_FAIL = "USER_REQUEST_FAIL"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGOUT = "USER_LOGOUT"
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS"
export const USER_UPDATE_HAVE_PASSWORD_SUCCESS = "USER_UPDATE_HAVE_PASSWORD_SUCCESS"
